import { CaptionBold } from '@comeon/ui';
import { FC } from 'react';
import HighlightedLabel from './highlighted-label';
import { OddsFormat } from '../sportsbook-types';
import formatOdds from '../utils/format-odds';

type AnimatedOddsDisplayProps = {
	odds: number;
	oddsFormat: OddsFormat;
	dataAt?: string;
	className?: string;
	hasHighlightedOdds?: boolean;
};

export const AnimatedOddsDisplay: FC<AnimatedOddsDisplayProps> = ({
	odds,
	oddsFormat,
	dataAt,
	className,
	hasHighlightedOdds = false
}) => {
	return (
		<HighlightedLabel className={className} isHighlighted={hasHighlightedOdds} dataAt={dataAt}>
			<CaptionBold>{formatOdds(odds, oddsFormat)}</CaptionBold>
		</HighlightedLabel>
	);
};

export default AnimatedOddsDisplay;
